import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router';

function NewFundingConsumerNameForm({ consumerFirstName, consumerLastName, consumerId }) {
  return (
    <div className="d-flex align-items-center gap-2 bo-funding-form-consumer-name pb-1">
      <p className="bo-common-text-xxl-bold text-truncate">
        {`${consumerFirstName} ${consumerLastName}`}
      </p>
      <Link className="bo-common-text" to={`/consumer/${consumerId}`}>
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} color="#5946A4" />
      </Link>
    </div>
  );
}

export default NewFundingConsumerNameForm;
